import { Box, Stack } from "@mui/material";
import { CartButton } from "../cart-button";
import { Item } from "./item";
import { TranslationContext } from "../../translation";
import React from "react";
export const Menu = ({ isSticky = false, menuItems = [], }) => {
    const { useCart } = React.useContext(TranslationContext);
    return (React.createElement(Stack, { alignItems: "center", component: "ul", direction: "row", role: "navigation", spacing: { xs: 5, lg: 7, xl: 9, pl: 0, pr: 0, pt: 0 }, sx: { pl: 0, listStyleType: "none" } },
        menuItems.map(({ label, route }) => (React.createElement(Box, { component: "li", key: `nav-item-${label}-${route}` },
            React.createElement(Item, { label: label, route: route, isSticky: isSticky })))),
        useCart && React.createElement(CartButton, { "data-testid": isSticky ? "cart-btn-sticky" : "cart-btn" })));
};
//# sourceMappingURL=menu.js.map